var _rect, _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFacebookNew = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M425 250C425 153.35 346.65 75 250 75C153.35 75 75 153.35 75 250C75 337.346 138.995 409.746 222.656 422.874V300.586H178.223V250H222.656V211.445C222.656 167.586 248.783 143.359 288.756 143.359C307.904 143.359 327.93 146.777 327.93 146.777V189.844H305.863C284.125 189.844 277.344 203.334 277.344 217.174V250H325.879L318.12 300.586H277.344V422.874C361.005 409.746 425 337.346 425 250Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318.12 300.586L325.879 250H277.344V217.174C277.344 203.334 284.125 189.844 305.863 189.844H327.93V146.777C327.93 146.777 307.904 143.359 288.756 143.359C248.783 143.359 222.656 167.586 222.656 211.445V250H178.223V300.586H222.656V422.874C231.567 424.272 240.696 425 250 425C259.304 425 268.433 424.272 277.344 422.874V300.586H318.12Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook_new.3bdcdd21.svg";
export { ForwardRef as ReactComponent };